// @ts-nocheck
import axios from 'config/api';
import { AxiosInstance } from 'axios';
import { API_DJANGO, API } from 'config/constants';
const platform = import.meta.env.VITE_PLATFORM;

const config = platform === 'django' ? API_DJANGO : API;

export const api = axios.create(config);

export const authenticated = (apiInstance: AxiosInstance) => {
  const token = localStorage.getItem('token');
  const tenant = localStorage.getItem('tenant');

  apiInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  apiInstance.defaults.headers.common['tenant-id'] = tenant;

  return apiInstance;
};
